// src/firebase/config.js
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

// ✅ Configuración obtenida de Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyC2mPhDn-UCJFvQrHvJrN8CEzCOAXotIjs",
  authDomain: "vvmone-be737.firebaseapp.com",
  projectId: "vvmone-be737",
  storageBucket: "vvmone-be737.firebasestorage.app",
  messagingSenderId: "816196395803",
  appId: "1:816196395803:web:df6a706a71ceefde5729be",
  measurementId: "G-15SDYWFQ4C"
}

// ✅ VAPID Key (Web Push certificate)
// IMPORTANTE: Esta key debe obtenerse de:
// Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
// Si aún no tienes una, genera un par de claves y usa la "Key pair"
const VAPID_KEY = 'BFkKVd3M1BFs-vcshhnaAKlQ3oaHgrwb6aMqN57gLaVi-5wkd9A0bXLdnnNNL4evSsIWZ1BP_teOjwvKhVpnzc8'

// ✅ Inicializar Firebase
let app = null
let messaging = null

try {
  app = initializeApp(firebaseConfig)
  console.log('🔥 Firebase App inicializada correctamente')
  
  // Solo intentar obtener messaging si estamos en un contexto seguro (HTTPS o localhost)
  if (typeof window !== 'undefined' && (window.location.protocol === 'https:' || window.location.hostname === 'localhost')) {
    try {
      messaging = getMessaging(app)
      console.log('📱 Firebase Messaging inicializado correctamente')
    } catch (msgError) {
      console.warn('⚠️ Firebase Messaging no disponible:', msgError.message)
    }
  } else {
    console.warn('⚠️ Firebase Messaging requiere HTTPS o localhost')
  }
} catch (error) {
  console.error('❌ Error inicializando Firebase:', error)
}

// ✅ Función helper para verificar si messaging está disponible
export const isMessagingAvailable = () => {
  return messaging !== null
}

// ✅ Función helper para verificar soporte de notificaciones
export const areNotificationsSupported = () => {
  return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
}

export { app, messaging, getToken, onMessage, VAPID_KEY }